const en = {
  global: {
    home: "Home",
    logout: "Logout",
    language: {
      chinese: "Chinese",
      english: "English"
    },
    changePwd: "Change Password"
  },
  breadcumb: {
    changePwd: "Change Password",
  },
  login: {
    title: "Shiji Pay",
    tips: "简体中文",
    loginBtn: "Sign in",
    accounts_pass_login: "Sign in",
    remember: "remember",
    register: "register",
    forget_pass: "forgetPassword",
    username_placeholder: "Please input username or email",
    password_placeholder: "Please input a password",
    verifyCode_placeholder: "Please input verifyCode",
    password_invaild: "Password length cannot be less than 5 digits"
  },
  register: {
    name: "register",
    title1: "register",
    userName: "userName",
    userEmail: "email",
    verifyCode: "verifyCode",
    title2: "Please enter your password",
    password: "password",
    password2: "repeatPassword",
  },
  resetPwd: {
    name: "resetPassword",
    title1: "Please enter your email",
    userEmail: "email",
    verifyCode: "verifyCode",
    title2: "Please enter your password",
    password: "password",
    password2: "repeatPassword",
  },
  home: {
    name: "Home",
    app_title: "My App List",
    update_log: "Update Logs", 
  },
  profile: {
    profile: "Profile",
    user_name: "User Name",
    account_id: "Account Id",
    teller_type: "Teller_type",
    expiration_time: "Expiration Time",
    changePwd: "Change Password",
    old_password: "Old Password",
    new_password: "New Password",
    confirm_password: "Confirm Password" ,
    new_password_strongth: "New Password Strongth" 
  },


  user: {
    name: "UserManager"
  },
  setting: {
    name: "SystemConfig"
  },
  operationLog: {
    name: "operationLog"
  },
  role: {
    name: "RoleManager"
  },
  // dashboard: {
  //   name: "Dashboard",
  //   panel_group: {
  //     trans: "Water Query",
  //     hist_trans: "Transaction Detail",
  //     pre_auth_trans: "Pre Authorization",

  //     accounts: "Audit account "
  //   }
  // },

  // element组件翻译
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "Clear"
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: ""
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"], // to be translated
      filterPlaceholder: "Enter keyword", // to be translated
      noCheckedFormat: "{total} items", // to be translated
      hasCheckedFormat: "{checked}/{total} checked" // to be translated
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back" // to be translated
    }
  }
};
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js